import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, AvatarFallback, AvatarImage } from '@repo/ui-primitives/avatar';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@repo/ui-primitives/tooltip';
import { Link } from '@tanstack/react-router';
const AvatarWrapper = (param)=>{
    let { children, href, style } = param;
    return href ? /*#__PURE__*/ _jsx(Link, {
        to: href,
        "data-e2e": "avatar-item-link",
        style: style,
        children: children
    }) : /*#__PURE__*/ _jsx("div", {
        style: style,
        children: children
    });
};
const AvatarItem = (param)=>{
    let { avatar, disableTooltip, style } = param;
    const { avatarColor, name, imageSrc, href } = avatar;
    const initials = name.split(' ').map((n)=>n[0]).join('').toUpperCase().slice(0, 2);
    const avatarElement = /*#__PURE__*/ _jsxs(Avatar, {
        "data-e2e": "avatar-item",
        className: "h-[30px] w-[30px] text-base border-2 rounded-full border-[#343434]",
        style: {
            backgroundColor: avatarColor ? "".concat(avatarColor) : '#343434'
        },
        children: [
            /*#__PURE__*/ _jsx(AvatarImage, {
                src: imageSrc !== null && imageSrc !== void 0 ? imageSrc : undefined,
                alt: name
            }),
            /*#__PURE__*/ _jsx(AvatarFallback, {
                children: initials
            })
        ]
    });
    return /*#__PURE__*/ _jsx(AvatarWrapper, {
        href: href,
        style: style,
        children: disableTooltip ? avatarElement : /*#__PURE__*/ _jsx(TooltipProvider, {
            children: /*#__PURE__*/ _jsxs(Tooltip, {
                children: [
                    /*#__PURE__*/ _jsx(TooltipTrigger, {
                        asChild: true,
                        children: avatarElement
                    }),
                    /*#__PURE__*/ _jsx(TooltipContent, {
                        children: name
                    })
                ]
            })
        })
    });
};
export { AvatarItem };
